var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListcheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "13px",
    viewBox: "0 0 15 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "06---Index---Elaborazione-contratti---Nuova-elaborazione",
    transform: "translate(-1292.000000, -43.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(288.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Btn-Copy",
    transform: "translate(987.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fact_check_black_24dp",
    transform: "translate(16.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1666667,2.125 L2.83333333,2.125 C2.05416667,2.125 1.41666667,2.7625 1.41666667,3.54166667 L1.41666667,13.4583333 C1.41666667,14.2375 2.05416667,14.875 2.83333333,14.875 L14.1666667,14.875 C14.9458333,14.875 15.5833333,14.2375 15.5833333,13.4583333 L15.5833333,3.54166667 C15.5833333,2.7625 14.9458333,2.125 14.1666667,2.125 Z M7.08333333,12.0416667 L3.54166667,12.0416667 L3.54166667,10.625 L7.08333333,10.625 L7.08333333,12.0416667 Z M7.08333333,9.20833333 L3.54166667,9.20833333 L3.54166667,7.79166667 L7.08333333,7.79166667 L7.08333333,9.20833333 Z M7.08333333,6.375 L3.54166667,6.375 L3.54166667,4.95833333 L7.08333333,4.95833333 L7.08333333,6.375 Z M10.4975,10.625 L8.5,8.61333333 L9.49875,7.61458333 L10.4975,8.62041667 L12.7429167,6.375 L13.74875,7.38083333 L10.4975,10.625 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListcheck);
export default __webpack_public_path__ + "static/media/listcheck.abd81876448bb61eafccf6cd3ae07969.svg";
export { ForwardRef as ReactComponent };